import { FC } from 'react';
import { Input, Typography } from 'antd';

import s from './index.module.scss';

type SettingsDisabledInputProps = {
	className?: string;
	name?: string;
	value?: string;
};

export const SettingsDisabledInput: FC<SettingsDisabledInputProps> = ({
	className,
	name,
	value,
}) => {
	return (
		<div className={className}>
			<Typography.Text className={s.text}>{name}</Typography.Text>
			<Input className={s.input} disabled value={value} />
		</div>
	);
};
